import { render, staticRenderFns } from "./CC-clientes.vue?vue&type=template&id=e27e28a4"
import script from "./CC-clientes.vue?vue&type=script&lang=js"
export * from "./CC-clientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports